import { pxToRem } from './biomeTokens';
import { colorTheme } from './extendedColors';

const textInput = {
  height: pxToRem(40),
  field: {
    border: `${pxToRem(1)} solid`,
    borderColor: colorTheme.stroke[200],
    borderRadius: pxToRem(3),
    color: colorTheme.text['highEmphasis'],
    focusBorderColor: colorTheme.stroke[400],
    fontSize: pxToRem(14),
    pl: pxToRem(12),
    _placeholder: {
      color: colorTheme.text['lowEmphasis']
    },
    _hover: {
      borderColor: colorTheme.stroke[300]
    },
    _active: {
      borderColor: colorTheme.stroke[200],
      color: colorTheme.text['highEmphasis']
    },
    _focus: {
      borderColor: colorTheme.stroke[400]
    },
    _invalid: {
      borderColor: colorTheme.alert[500]
    },
    _disabled: {
      bg: colorTheme.structural[300],
      borderColor: colorTheme.stroke[200],
      color: colorTheme.text['highEmphasis']
    },
    _info: {
      borderColor: colorTheme.stroke[400]
    },
    _autofill: {
      transition: 'background-color 5000s ease-in-out 0s'
    }
  },
  element: {
    color: colorTheme.stroke[300]
  },
  addon: {
    border: `${pxToRem(1)} solid`,
    borderColor: colorTheme.structural[300],
    bg: colorTheme.structural[300],
    color: colorTheme.structural[300],
    pt: pxToRem(6),
    pb: pxToRem(6),
    pl: pxToRem(10),
    pr: pxToRem(10)
  }
};

const searchInput = {
  height: pxToRem(40),
  field: {
    border: `${pxToRem(1)} solid`,
    borderColor: colorTheme.stroke[200],
    borderRadius: pxToRem(3),
    color: colorTheme.text['highEmphasis'],
    focusBorderColor: colorTheme.stroke[400],
    _placeholder: {
      color: colorTheme.text['lowEmphasis']
    },
    _hover: {
      borderColor: colorTheme.stroke[300]
    },
    _active: {
      borderColor: colorTheme.stroke[200],
      color: colorTheme.text['highEmphasis']
    },
    _focus: {
      borderColor: colorTheme.stroke[400]
    },
    _invalid: {
      borderColor: colorTheme.alert[500]
    },
    _disabled: {
      bg: colorTheme.structural[300],
      borderColor: colorTheme.stroke[200],
      color: colorTheme.text['highEmphasis']
    },
    _info: {
      borderColor: colorTheme.stroke[400]
    }
  },
  element: {
    color: colorTheme.foundation[300],
    pl: pxToRem(12),
    pr: pxToRem(12),
    pt: pxToRem(16),
    pb: pxToRem(16)
  },
  addon: {
    border: `${pxToRem(1)} solid`,
    borderColor: colorTheme.structural[300],
    bg: colorTheme.structural[300],
    color: colorTheme.stroke[300],
    pt: pxToRem(6),
    pb: pxToRem(6),
    pl: pxToRem(10),
    pr: pxToRem(10)
  }
};

export const formStyles = {
  parts: [
    'control',
    'container',
    'requiredIndicator',
    'helperText',
    'errorMessage'
  ],
  baseStyle: {
    control: {
      height: pxToRem(60)
    },
    container: {
      label: {
        color: colorTheme.text['highEmphasis'],
        fontSize: pxToRem(11.67)
      }
    },
    requiredIndicator: {
      color: colorTheme.success[500],
      fontSize: pxToRem(11.67)
    },
    helperText: {
      mt: pxToRem(8),
      color: colorTheme.text['mediumEmphasis'],
      fontSize: pxToRem(11.67)
    },
    errorMessage: {
      color: colorTheme.alert[500],
      fontSize: pxToRem(11.67)
    }
  }
};

export const formError = {
  baseStyle: {
    text: { color: colorTheme.alert[500] }
  }
};

export const inputTheme = {
  variants: { text: textInput, search: searchInput }
};

export const checkboxSizes = {
  md: {
    control: {
      height: pxToRem(12),
      width: pxToRem(12)
    },
    label: {
      marginLeft: pxToRem(8)
    }
  }
};

export const checkboxTheme = { sizes: checkboxSizes };
